import React from 'react';
import AnimatedLogo from '@/components/AnimatedLogo';
import Backdrop from '@mui/material/Backdrop';
import { randomString } from '@/lib/helpers/helpers';

const InitialLoading: React.FC<{ sx?: any; id?: string; 'data-testid'?: string }> = ({
    sx = {},
    id = '',
    'data-testid': testId,
}) => {
    const wrapSx = sx ? { ...sx } : {};

    return (
        <Backdrop
            data-testid={testId}
            id={id || randomString(12)}
            sx={{
                color: (theme) => theme.palette.primary.main,
                zIndex: (theme) => theme.zIndex.drawer + 1000,
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                ...wrapSx,
            }}
            open
            onClick={() => {}}
        >
            <AnimatedLogo />
        </Backdrop>
    );
};

export default InitialLoading;
